import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  UpdateSettingsPage,
  getSettingsListAll,
} from "../../../redux/settings/action";
import { useFormik } from "formik";
import Spinner from "../../Layouts/Spinner";
import { contactInfoValidation } from "../../Constant/constant";
import MapComponent from "../SfInvoice/CotactAddress";
import PhoneInput from "react-phone-input-2";


const ContactInfo = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const settingsListData = useSelector(
    (state) => state?.reusableSlice?.settingsListData
  );
  console.log(settingsListData,"settingsListData")

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      mobile: Number(settingsListData?.mobile) || "",
      email: settingsListData?.email || "",
      address: settingsListData?.address || "",
      latitude: settingsListData.latitude || "",
      longitude: settingsListData.longitude || "",
      country_code:settingsListData?.country_code||"",
      facebook:settingsListData?.facebook||"",
      linkedin:settingsListData?.linkedin||"",
      instagram:settingsListData?.instagram||"",
      x:settingsListData?.x||"",




    },
    validationSchema: contactInfoValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      ...values,
      id: settingsListData.id,
    };
    dispatch(UpdateSettingsPage(data, setLoading));
  };

  useEffect(() => {
    dispatch(getSettingsListAll());
  }, [dispatch]);

  const handleCountryCode = (value, data) => {
    formik.setFieldValue(
      "mobile",
      `${value.slice(data.dialCode.length)}`
    );
    formik.setFieldValue("country_code", `+${data.dialCode}`);
  };

  console.log(formik.errors, "addsfdsfdsfsdf");

  return (
    <div className="">
      <h3 className="pb-3">Contact Info</h3>
      <form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-md-4 form-group">
          <div className="form-group">
                      <label htmlFor="mobile">Mobile Number</label>
                      <PhoneInput
                        country={"in"}
                        value={
                          formik?.values.country_code
                            ? `${formik.values.country_code}${formik.values.mobile}`
                            : ""
                        }
                        onChange={(phone, data) =>
                          handleCountryCode(phone, data)
                        }
                        onBlur={() => formik.setFieldTouched("mobile", true)}
                      />
                    </div>
            {formik.touched.mobile && formik.errors.mobile ? (
              <div className="error">{formik.errors.mobile}</div>
            ) : null}
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="referral_duration_type">Email</label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter Email Address"
              name="email"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />
            {formik.touched.email && formik.errors.email ? (
              <div className="error">{formik.errors.email}</div>
            ) : null}
          </div>
          <div className="form-group col-md-4">
          <label htmlFor="referral_duration_type">Address</label>
            <MapComponent
              prop={{ name: "address" }}
              value={formik.values.address}
              formik={formik}
              setFieldValue={formik.setFieldValue}
              x={formik.values.latitude}
              y={formik.values.longitude}
            />
            {formik.touched.address && formik.errors.address ? (
              <div className="error">{formik.errors.address}</div>
            ) : null}
          </div>
          <div className="form-group col-md-4">
            <label htmlFor="referral_duration_type">TikTok</label>
            <input
              type="facebook"
              className="form-control"
              placeholder="Enter TikTok URL"
              name="facebook"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.facebook}
            />
            {formik.touched.facebook && formik.errors.facebook ? (
              <div className="error">{formik.errors.facebook}</div>
            ) : null}
          </div>
          <div className="form-group col-md-4">
            <label htmlFor="referral_duration_type">WhatsApp</label>
            <input
              type="linkedin"
              className="form-control"
              placeholder="Enter WhatsApp URL"
              name="linkedin"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.linkedin}
            />
            {formik.touched.linkedin && formik.errors.linkedin ? (
              <div className="error">{formik.errors.linkedin}</div>
            ) : null}
          </div>
          <div className="form-group col-md-4">
            <label htmlFor="referral_duration_type">Instagram</label>
            <input
              type="instagram"
              className="form-control"
              placeholder="Enter instagram url"
              name="instagram"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.instagram}
            />
            {formik.touched.instagram && formik.errors.instagram ? (
              <div className="error">{formik.errors.instagram}</div>
            ) : null}
          </div>
          <div className="form-group col-md-4">
            <label htmlFor="referral_duration_type">X</label>
            <input
              type="x"
              className="form-control"
              placeholder="Enter x url"
              name="x"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.x}
            />
            {formik.touched.x && formik.errors.x ? (
              <div className="error">{formik.errors.x}</div>
            ) : null}
          </div>
        </div>
        <button
          className="submit-btn d-block mx-auto mt-3  "
          style={{ width: "max-content" }}
          type="submit"
        >
          {!loading ? "Submit" : <Spinner />}
        </button >
      </form>
    </div>
  );
};

export default ContactInfo;
